import {makeThemeProps} from "@themes/default/props/utils";

export default (theme, categoryBarProps, site) => {
  const themeStyles = makeThemeProps(theme, site);
  return themeStyles.getCategoryBarProps(theme, categoryBarProps, site);
};
